import ErrorState from '@zenbusiness/zui/ErrorState';

import ErrorBoundary from '#client/components/ErrorBoundary';
import { RELEASE_INVOICING_FEATURE_ANNOUNCEMENT_BANNER } from '#client/constants/experimentsFlags';
import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import useFeatureFlag from '#client/hooks/useFeatureFlag';

import { Wrapper } from './BalanceBox.styles';
import AvailableBalance from './components/AvailableBalance';
import NavigationButtons from './components/NavigationButtons';
import NavigationButtonsV2 from './components/NavigationButtonsV2';

export default function BalanceBox() {
  const [isEnableInvoicingFeatureBanner] = useFeatureFlag(
    RELEASE_INVOICING_FEATURE_ANNOUNCEMENT_BANNER
  );

  const { entitlements } = useConstBusinessEntityUuid();

  const hasBanking = entitlements.has('banking');
  const hasMoneyPro = entitlements.has('money_pro');

  const isShowInvoicingButton = hasBanking && !hasMoneyPro;

  return (
    <Wrapper>
      <AvailableBalance />
      <ErrorBoundary
        fallback={
          <ErrorState
            slotProps={{
              primaryAction: {
                eventProps: {
                  pageSection: 'banking'
                }
              }
            }}
          />
        }
      >
        {isEnableInvoicingFeatureBanner && isShowInvoicingButton ? (
          <NavigationButtonsV2 />
        ) : (
          <NavigationButtons />
        )}
      </ErrorBoundary>
    </Wrapper>
  );
}
